export default "__VITE_ASSET__BMkP6Fmy__"